<template>
    <div class="main">
        <div class="title-bar">
            <h1>{{ user.first_name }} {{ user.last_name }} Surveys</h1>
            <!-- <a :href="route('admin.surveys.index')" class="btn-back">
                <span class="icon icon-arrow-left"></span>
                <span class="text">Back to Survey List</span>
            </a> -->
        </div>

        <div class="content p-3 p-md-4 px-xxl-5">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <Alert v-if="hasAlert" :alert="alert" />
                    </transition>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <h2 v-show="type == 'event'">Classroom Events</h2>
                    <h2 v-show="type == 'course'">Online Courses</h2>
                    <div class="d-flex mt-4">
                        <div class="select-wrapper ml-2">
                            <select v-model="type" class="custom-select" id="survey-type" v-if="numTypes > 1"> 
                                <option value="event">Classroom Events</option>
                                <option value="course">Online Courses</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2" v-if="surveys && surveys.length">
                    <table class="listable w-100">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th v-if="type == 'event'">Start Date</th>
                            </tr>
                        </thead>
                        <tbody>                            
                            <tr :key="survey.id" v-for="survey in surveys" class="survey listable-data" v-show="type == survey.type">
                                <td class="td">
                                    {{survey.course_id ? survey.course_id : survey.event_id}}
                                </td>
                                <td class="td">
                                    <a :href="getSurveyUrl(survey)">
                                        {{survey.name}}
                                    </a>
                                </td>
                                <td class="td" v-if="type == 'event'">{{survey.start_date | moment("MM/DD/YYYY")}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mt-2" v-else>
                    <p>
                        <i>There are currently no open surveys for this trainer.</i>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import DetailsPane from "components/partials/Users/DetailsPane";

export default {
    mixins: [DisplaysAlerts],
    components: { DetailsPane },
    props: {
        user: { type: Object, required: true },
        surveys: { type: Array | null },
    },
    data() {
        return {
            type: 'event',
            numTypes: 0,
            hasEvents: 0,
            hasCourses: 0
        };
    },
    methods: {
        getSurveyUrl(survey) {
            let params = {};
            if (survey.type == 'course') {
                params = { course: survey.course_id };
            } else {
                params = { event: survey.event_id };
            } 
            
            return this.route('surveys.'+ survey.type +'.form', params);
        },
        capitalizeFirstLetter(string) {
           return string.charAt(0).toUpperCase() + string.slice(1);
        },
        changeType(type) {
            this.type = type;
        }
    },
    watch: {},
    created() {
        for (let key in this.surveys) {
            let survey = this.surveys[key];
            if (survey.type == 'course') {
                this.hasCourses = 1;
            } else {
                this.hasEvents = 1;
            } 
        }

        if (this.hasEvents) {
            this.type = 'event';
        } else {
            this.type = 'course';
        } 

        this.numTypes = this.hasCourses + this.hasEvents;
    }
};
</script>
<style lang="scss">
.survey span:first-letter {
    text-transform: uppercase;
}
.headers h3 {
    cursor: pointer;
}
.headers .active {
    color: var(--primary);
}
.listable {
    border-spacing: 0 12px !important;
    border-collapse: separate !important;
}
.listable .survey.listable-data {
    background-color: #ffffff;
    box-shadow: 0 2px 10px -2px #999999;
    margin-bottom: 0.5rem;
}
.survey.listable-data td.td {
    display: table-cell;
}
</style>